import * as React from "react";
import { useState, useContext } from "react";
import Parser from "html-react-parser";
import { GeneralContext } from "../../context/GeneralContext";
import LoadingButton from "@mui/lab/LoadingButton";

import {
  Backdrop,
  Box,
  Button,
  Modal,
  Typography,
  Stack,
  ButtonBase,
} from "@mui/material";

export default function ModalConfirmar(props) {
  const [open, setOpen] = useState(false);
  const { loadingModal, setLoadingModal } = useContext(GeneralContext)

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {/* La prop useDiv es un "indicador" o "interruptor" que le das a tu componente ModalConfirmar. 
    Esta propiedad se utiliza para indicar al componente que debe utilizar un div en lugar de un ButtonBase 
    para envolver a sus hijos. */}
      {/* TODO height div */}
        {!props.envuelveBoton ? (
          props.useDiv ? (
            <span onClick={handleOpen}>{props.children}</span>
            ) : (
            <ButtonBase onClick={handleOpen}>{props.children}</ButtonBase> //Envuelve el hijo conviertiendolo en boton
              )
        ) : (props.children)}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 200,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "80%", md: "60%" },
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
            height: {xs: '80%', sm: "auto"},
            overflow: {xs: 'scroll', sm: "hidden"}
          }}
        >
          <Stack spacing={2}>
            <Typography
              id="transition-modal-title"
              variant="tituloModal"
              sx={{ fontWeight: "bold" }}
            >
              {Parser(props.title)}
            </Typography>
            <Typography
              id="transition-modal-description"
              textAlign={"justify"}
              variant="parrafo"
              sx={{ mt: 2 }}
            >
              {Parser(props.text)}
            </Typography>
          </Stack>
          <Stack
            direction={"row"}
            spacing={2}
            marginTop={3}
            justifyContent={"flex-end"}
          >
            <LoadingButton
              onClick={() => {
                handleClose()
              }}
              loading={loadingModal}
              variant="contained"
            >
              {props.cancelText}
            </LoadingButton>
            {props.onContinue && (
              <LoadingButton
                onClick={() => {
                  if (props.deshabilitar) {
                    setLoadingModal(true);
                  }
                  props.onContinue()
                }}
                loading={loadingModal}
                variant="contained"
              >
                {props.continueText}
              </LoadingButton>
            )}
          </Stack>
        </Box>
      </Modal>
    </>
  );
}
